import { useEffect } from "react";

function Cabinet() {
  useEffect(() => {
    document.title = "Cabinet";
  });
  return (
    <div class="content">
      <div class="w-container">
        <div class="page-head">
          <div class="page-title">
            <h1 class="h1">Cabinet</h1>
          </div>
          <div className="flex-vert" style={{ marginTop: "-10px" }}>
            <div class="sub-hrule"></div>
            <p class="paragraph-center sub">
              Cabinet is Wiess’ governing body, which holds open meetings every
              Wednesday in the Upper Commons or Large Classroom. All Wiessmen
              are encouraged to partake in the precarious balance of bedlam and
              decision-making that ensues at Cabinet.

              {/* <a href = "/wiess/public/images/general/Wiess Constitution.pdf"> Constitution Test</a> */}
              
            </p>
          </div>
        </div>
        <div class="people-section">
          <div id="cabinetnav" class="from-navbar-ref"></div>
          <div id="cabinet" class="page-nav-ref"></div>
          { /*
          <div class="sub-head" style={{ position: "relative", width: "100%", paddingBottom: "56.25%", height: "0", overflow: "hidden", marginBottom: "60px" }}>
            <iframe
              style={{ position: 'absolute', top: "0", left: "0", width: '100%', height: '100%' }}
              src="https://www.youtube.com/embed/qfL_Jvc5V_8"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              title="cabVid"
            ></iframe>
          </div>
          */ }
          <div class="people-grid">
            <div class="person-card" id="court-CJ-card-holder">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Isabelle Shen.jpg"
                  height="200"
                  alt="Isabelle Shen"
                ></img>
              </div>
              <div>
                <p class="position">President</p>
              </div>
              <div class="name">
                <h4 class="h4">Isabelle Shen</h4>
              </div>
              <div>
                <a
                  class="position"
                  href="mailto: wiesscollegepresident@gmail.com"
                >
                  <u>wiesscollegepresident@gmail.com</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/virginia-minard.jpg"
                  height="200"
                  alt="Virginia Minard"
                />
              </div>
              <div>
                <p class="position">Chief Justice</p>
              </div>
              <div class="name">
                <h4 class="h4">Virginia Minard</h4>
              </div>
              <div>
                <a class="position" href="mailto: wiesscourt@gmail.com">
                  <u>wiesscourt@gmail.com</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Iyad Kelifa.png"
                  height="200"
                  alt="Iyad Kelifa"
                />
              </div>
              <div>
                <p class="position">Internal Vice President</p>
              </div>
              <div class="name">
                <h4 class="h4">Iyad Kelifa</h4>
              </div>
              <div>
                <a class="position" href="mailto: wiesscollegeivp@gmail.com">
                  <u>wiesscollegeivp@gmail.com</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Jaden Alleman.jpeg"
                  height="200"
                  alt="Jaden Alleman"
                />
              </div>
              <div>
                <p class="position">External Vice President</p>
              </div>
              <div class="name">
                <h4 class="h4">Jaden Alleman</h4>
              </div>
              <div>
                <a class="position" href="mailto: wiesscollegeevp@gmail.com">
                  <u>wiesscollegeevp@gmail.com</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Alyce Richmond.jpeg"
                  height="200"
                  alt="Alyce Richmond"
                />
              </div>
              <div>
                <p class="position">Social Vice President</p>
              </div>
              <div class="name">
                <h4 class="h4">Alyce Richmond</h4>
              </div>
              <div>
                <a class="position" href="mailto: wiesssocialvp@gmail.com">
                  <u>wiesssocialvp@gmail.com</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Claire Thacker.JPG"
                  height="200"
                  alt="Wiess Crest"
                />
              </div>
              <div>
                <p class="position">Social Vice President</p>
              </div>
              <div class="name">
                <h4 class="h4">Claire Thacker</h4>
              </div>
              <div>
                <a class="position" href="mailto: wiesssocialvp@gmail.com">
                  <u>wiesssocialvp@gmail.com</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Henrik Chan.jpeg"
                  height="200"
                  alt="Henrik Chan"
                />
              </div>
              <div>
                <p class="position">Head Treasurer</p>
              </div>
              <div class="name">
                <h4 class="h4">Henrik Chan</h4>
              </div>
              <div>
                <a class="position" href="mailto: he123@rice.edu">
                  <u>he123@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Deivanai Palaniappan.jpg"
                  height="200"
                  alt="Deivanai Palaniappan"
                />
              </div>
              <div>
                <p class="position">Apprentice Treasurer</p>
              </div>
              <div class="name">
                <h4 class="h4">Deivanai Palaniappan</h4>
              </div>
              <div>
                <a class="position" href="mailto: dp125@rice.edu">
                  <u>dp125@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Olivia Qiu.jpeg"
                  height="200"
                  alt="Olivia Qiu"
                />
              </div>
              <div>
                <p class="position">SA Senator</p>
              </div>
              <div class="name">
                <h4 class="h4">Olivia Qiu</h4>
              </div>
              <div>
                <a
                  class="position" href="mailto: wiesscollegesenator@gmail.com"
                >
                  <u>wiesscollegesenator@gmail.com</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Jenny Karsner.jpg"
                  height="200"
                  alt="Jenny Karsner"
                />
              </div>
              <div>
                <p class="position">Senior Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">Jenny Karsner</h4>
              </div>
              <div>
                <a class="position" href="mailto: jfk11@rice.edu">
                  <u>jfk11@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Eli Risinger.jpeg"
                  height="200"
                  alt="Eli Risinger"
                />
              </div>
              <div>
                <p class="position">Junior Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">Eli Risiniger</h4>
              </div>
              <div>
                <a class="position" href="mailto: er78@rice.edu">
                  <u>er78@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                  <img
                  src="/images2026-27/cab-faces/Akul Mittal.jpg"
                    height="200"
                    alt="Wiess Crest"
                  />
              </div>
              <div>
                <p class="position">Sophomore Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">Akul Mittal</h4>
              </div>
              <div>
                <a class="position" href="mailto: am557@rice.edu">
                  <u>am557@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Sergio Rodriguez.jpeg"
                  height="200"
                  alt="Sergio Rodriguez"
                />
              </div>
              <div>
                <p class="position">Sophomore Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">Sergio Rodriguez</h4>
              </div>
              <div>
                <a class="position" href="mailto: sr232@rice.edu">
                  <u>sr232@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Hibah Rahman.jpeg"
                  height="200"
                  alt="Hibah Rahman"
                />
              </div>
              <div>
                <p class="position">Diversity Chair</p>
              </div>
              <div class="name">
                <h4 class="h4">Hibah Rahman</h4>
              </div>
              <div>
                <a class="position" href="mailto: hr36@rice.edu">
                  <u>hr36@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Jooheon Lee.jpeg"
                  height="200"
                  alt="Jooheon Lee"
                />
              </div>
              <div>
                <p class="position">Diversity Chair</p>
              </div>
              <div class="name">
                <h4 class="h4">Jooheon Lee</h4>
              </div>
              <div>
                <a class="position" href="mailto: jl587@rice.edu">
                  <u>jl587@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                  <img
                  src="/images2026-27/cab-faces/Ethan Lopez Touchy.jpg"
                    height="200"
                    alt="Wiess Crest"
                  />
              </div>
              <div>
                <p class="position">Secretary</p>
              </div>
              <div class="name">
                <h4 class="h4">Ethan Lopez Touchy</h4>
              </div>
              <div>
                <a
                  class="position"
                  href="mailto: wiesscollegesecretary@gmail.com"
                >
                  <u>wiesscollegesecretary@gmail.com</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Jasmine Godoy.jpg"
                  height="200"
                  alt="Jasmine Godoy"
                />
              </div>
              <div>
                <p class="position">Secretary</p>
              </div>
              <div class="name">
                <h4 class="h4">Jasmine Godoy</h4>
              </div>
              <div>
                <a
                  class="position"
                  href="mailto: wiesscollegesecretary@gmail.com"
                >
                  <u>wiesscollegesecretary@gmail.com</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Janaki venepally.jpeg"
                  height="200"
                  alt="Janaki Venepally"
                />
              </div>
              <div>
                <p class="position">Parliamentarian</p>
              </div>
              <div class="name">
                <h4 class="h4">Janaki Venepally</h4>
              </div>
              <div>
                <a class="position" href="mailto: jv65@rice.edu">
                  <u>jv65@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Aaryan Vira.jpg"
                  height="200"
                  alt="Aaryan Vira"
                />
              </div>
              <div>
                <p class="position">Historian</p>
              </div>
              <div class="name">
                <h4 class="h4">Aaryan Vira</h4>
              </div>
              <div>
                <a class="position" href="mailto: av123@rice.edu">
                  <u>av123@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                  <img
                    src="/images2026-27/cab-faces/Sofia Garcia.jpeg"
                    height="200"
                    alt="Wiess Crest"
                  />
              </div>
              <div>
                <p class="position">Historian</p>
              </div>
              <div class="name">
                <h4 class="h4">Sofia Garcia</h4>
              </div>
              <div>
                <a class="position" href="mailto: slg10@rice.edu">
                  <u>slg10@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Aoife Shannon.jpeg"
                  height="200"
                  alt="Aoife Shannon"
                />
              </div>
              <div>
                <p class="position">Academics and Career Chair</p>
              </div>
              <div class="name">
                <h4 class="h4">Aoife Shannon</h4>
              </div>
              <div>
                <a class="position" href="mailto: as375@rice.edu">
                  <u>as375@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Madeline Pinches.jpeg"
                  height="200"
                  alt="Madeline Pinches"
                />
              </div>
              <div>
                <p class="position">Academics and Career Chair</p>
              </div>
              <div class="name">
                <h4 class="h4">Madeline Pinches</h4>
              </div>
              <div>
                <a class="position" href="mailto: mp157@rice.edu">
                  <u>mp157@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Owen Marye.jpeg"
                  height="200"
                  alt="Owen Marye"
                />
              </div>
              <div>
                <p class="position">Capital Improvements Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">Owen Marye</h4>
              </div>
              <div>
                <a class="position" href="mailto: om18@rice.edu">
                  <u>om18@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images/general/crest-color.png"
                  height="200"
                  alt="Off-Campus Representative"
                />
              </div>
              <div>
                <p class="position">Off-Campus Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">David Schaefer</h4>
              </div>
              <div>
                <a class="position" href="mailto: ds216@rice.edu">
                  <u>ds216@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                  <img
                    src="/images2026-27/cab-faces/Olivia Brazier.jpg"
                    height="200"
                    alt="Wiess Crest"
                  />
              </div>
              <div>
                <p class="position">Off-Campus Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">Olivia Brazier</h4>
              </div>
              <div>
                <a class="position" href="mailto: ob27@rice.edu">
                  <u>ob27@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Apoorva Agarwal.jpg"
                  height="200"
                  alt="Wiess Crest"
                />
              </div>
              <div>
                <p class="position">SA New Student Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">Apoorva Agarwal</h4>
              </div>
              <div>
                <a class="position" href="mailto: aa578@rice.edu">
                  <u>aa578@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Colin Kish.jpg"
                  height="200"
                  alt="Wiess Crest"
                />
              </div>
              <div>
                <p class="position">SA New Student Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">Colin Kish</h4>
              </div>
              <div>
                <a class="position" href="mailto: cgk5@rice.edu">
                  <u>cgk5@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                  <img
                    src="/images2026-27/cab-faces/Kylie Perez.jpg"
                    height="200"
                    alt="Wiess Crest"
                  />
              </div>
              <div>
                <p class="position">First Year Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">Kylie Perez</h4>
              </div>
              <div>
                <a class="position" href="mailto: kkp7@rice.edu">
                  <u>kkp7@rice.edu</u>
                </a>
              </div>
            </div>            
            <div class="person-card">
              <div class="prof-pic">
                  <img
                    src="/images2026-27/cab-faces/saanvi doddaballapur.png"
                    height="200"
                    alt="Wiess Crest"
                  />
              </div>
              <div>
                <p class="position">First Year Representative</p>
              </div>
              <div class="name">
                <h4 class="h4">Saanvi Doddaballapur</h4>
              </div>
              <div>
                <a class="position" href="mailto: sm328@rice.edu">
                  <u>sm328@rice.edu</u>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cabinet;
